import React from 'react';
import classnames from "classnames";
import { useState } from 'react';
import { Fragment } from 'react';
import { Card, CardBody, Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap'
import { IndexTransports } from './IndexTransports';
import { IndexRack } from '../configuraciones/racks/IndexRack';
import { TabMenu } from 'primereact/tabmenu';

export const IndexTransportsRacks = () => {

    const [activeIndex, setActiveIndex] = useState(0);


    const items = [
        { label: 'Transportes' },
        { label: 'Gradillas' }
    ];

    return (
        
        <Fragment>
            <Container fluid={true} style={{  scrollBehavior: "smooth" , transform: "scale(0.8)",    width: "125%",    transformOrigin: "top left" }}>
                <Row>   
                    <Col sm="12">
                            <div>
                                <TabMenu 
                                    model={items} 
                                    activeIndex={activeIndex} 
                                    onTabChange={(e) => setActiveIndex(e.index)}
                                    className="custom-tabmenu-blue-report"
                                />
                            </div>
                            <div style={{ marginTop: "1rem" }}>
                                <div style={{ display: activeIndex === 0 ? "block" : "none" }}>
                                    <IndexTransports {...activeIndex} />
                                </div>
                                <div style={{ display: activeIndex === 1 ? "block" : "none" }}>
                                    <IndexRack {...activeIndex} />
                                </div>
                            </div>
                   
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
